import { parseISO } from 'date-fns';

/**
 * Parse a persisted date value into a Date in the viewer's LOCAL time.
 *
 * Date-only strings ("YYYY-MM-DD") must be read as local midnight, NOT UTC.
 * `new Date("2026-07-19")` parses the string as UTC per the ES spec, so in any
 * timezone behind UTC it lands on the previous day — which made the calendar
 * highlight the wrong day and the timeline plot bars one day early. `parseISO`
 * treats a bare date as local time, while full timestamps (with a time part or
 * offset, e.g. `createdAt`) still parse to the correct instant.
 *
 * Returns `undefined` for empty/unparsable input so callers can branch on it.
 */
export function parseLocalDate(value: string | null | undefined): Date | undefined {
  if (!value) return undefined;
  const date = parseISO(value);
  return Number.isNaN(date.getTime()) ? undefined : date;
}
